module.exports = __webpack_public_path__ + "media/content-creator/beauty-1-fe4a0133.png";